import React, { useState } from 'react';
import { Heart, UserPlus, ShieldCheck, MessageSquarePlus, Headphones, X, CheckCircle2, Phone, Mail, Clock, Send } from 'lucide-react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

export default function FloatingToolbar() {
  const [showFeedback, setShowFeedback] = useState(false);
  const [showSupport, setShowSupport] = useState(false);
  const [showSecurity, setShowSecurity] = useState(false);

  // Form states
  const [feedbackType, setFeedbackType] = useState('bug');
  const [feedbackContent, setFeedbackContent] = useState('');
  const [feedbackEmail, setFeedbackEmail] = useState('');
  const [feedbackSuccess, setFeedbackSuccess] = useState(false);

  const handleFeedbackSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!feedbackContent.trim()) return;

    // Simulate sending API
    setFeedbackSuccess(true);
    setTimeout(() => {
      setFeedbackSuccess(false);
      setFeedbackContent('');
      setFeedbackEmail('');
      setShowFeedback(false);
    }, 2000);
  };

  return (
    <>
      {/* Floating Toolbar Container */}
      <div className="hidden lg:flex fixed right-4 top-1/2 -translate-y-1/2 z-50 flex-col items-center gap-3 animate-in fade-in slide-in-from-right-5 duration-500">

        {/* Button 1: Saved Items (Heart) */}

        {/* Button 2: Profile CV (UserPlus) */}
        {/* <div className="relative group">
          <Link
            to="/dashboard/profile"
            className={cn(
              "w-12 h-12 rounded-full bg-white hover:bg-orange-50 flex items-center justify-center text-orange-500 shrink-0",
              "border border-gray-100 shadow-lg shadow-gray-200/50 transition-all duration-300 hover:scale-110 hover:text-orange-600"
            )}
          >
            <UserPlus size={20} />
          </Link>

          <div className="absolute right-full top-1/2 -translate-y-1/2 mr-3 px-3 py-1.5 bg-slate-800 text-white text-xs font-semibold rounded-lg whitespace-nowrap opacity-0 translate-x-2 pointer-events-none group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 shadow-md">
            Cập nhật Hồ sơ ứng tuyển
            <div className="absolute left-full top-1/2 -translate-y-1/2 border-[5px] border-transparent border-l-slate-800" />
          </div>
        </div> */}

        {/* Button 3: Guarantee Verification (ShieldCheck) */}
        <div className="relative group">
          <button
            onClick={() => setShowSecurity(true)}
            className={cn(
              "w-12 h-12 rounded-full bg-white hover:bg-orange-50 flex items-center justify-center text-orange-500 shrink-0",
              "border border-gray-100 shadow-lg shadow-gray-200/50 transition-all duration-300 hover:scale-110 hover:text-orange-600"
            )}
          >
            <ShieldCheck size={20} />
          </button>

          <div className="absolute right-full top-1/2 -translate-y-1/2 mr-3 px-3 py-1.5 bg-slate-800 text-white text-xs font-semibold rounded-lg whitespace-nowrap opacity-0 translate-x-2 pointer-events-none group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 shadow-md">
            Cam kết bảo mật & Xác thực
            <div className="absolute left-full top-1/2 -translate-y-1/2 border-[5px] border-transparent border-l-slate-800" />
          </div>
        </div>

        {/* Capsule Block: Feedback & Support */}
        <div className="bg-white rounded-2xl shadow-xl shadow-gray-200/60 border border-gray-100 flex flex-col items-center p-1 w-14 shrink-0">

          {/* Button 4: Góp ý */}
          <button
            onClick={() => setShowFeedback(true)}
            className="group/item flex flex-col items-center justify-center w-full py-2.5 rounded-xl hover:bg-orange-50 text-orange-500 transition-all duration-200 cursor-pointer"
          >
            <MessageSquarePlus size={20} className="transition-transform group-hover/item:scale-110" />
            <span className="text-[9px] font-bold text-gray-500 mt-1 transition-colors group-hover/item:text-orange-600">
              Góp ý
            </span>
          </button>

          {/* Capsule Divider */}
          <div className="w-8 h-[1px] bg-gray-100/80 my-0.5" />

          {/* Button 5: Hỗ trợ */}
          <button
            onClick={() => setShowSupport(true)}
            className="group/item flex flex-col items-center justify-center w-full py-2.5 rounded-xl hover:bg-orange-50 text-orange-500 transition-all duration-200 cursor-pointer"
          >
            <Headphones size={20} className="transition-transform group-hover/item:scale-110" />
            <span className="text-[9px] font-bold text-gray-500 mt-1 transition-colors group-hover/item:text-orange-600">
              Hỗ trợ
            </span>
          </button>

        </div>

      </div>

      {/* ── MODAL 1: FEEDBACK Form ── */}
      {showFeedback && (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[999] flex items-center justify-center p-4 animate-in fade-in duration-300">
          <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 max-w-md w-full overflow-hidden animate-in zoom-in-95 duration-200">
            {/* Modal Header */}
            <div className="bg-gradient-to-r from-orange-500 to-orange-600 px-6 py-4 flex items-center justify-between text-white">
              <div className="flex items-center gap-2">
                <MessageSquarePlus size={20} />
                <h3 className="font-bold text-base">Gửi ý kiến đóng góp</h3>
              </div>
              <button
                onClick={() => setShowFeedback(false)}
                className="w-8 h-8 rounded-full hover:bg-white/20 flex items-center justify-center text-white transition-colors"
              >
                <X size={18} />
              </button>
            </div>

            {/* Modal Body */}
            {feedbackSuccess ? (
              <div className="p-8 flex flex-col items-center justify-center text-center space-y-3">
                <CheckCircle2 size={56} className="text-green-500 animate-bounce" />
                <h4 className="font-bold text-gray-800 text-lg">Gửi góp ý thành công!</h4>
                <p className="text-sm text-gray-500 max-w-xs">
                  Cảm ơn bạn đã đóng góp ý kiến để giúp FnBHub ngày càng hoàn thiện hơn.
                </p>
              </div>
            ) : (
              <form onSubmit={handleFeedbackSubmit} className="p-6 space-y-4">
                <p className="text-xs text-gray-500">
                  Ý kiến của bạn là vô cùng quý giá để cải tiến trải nghiệm người dùng và hệ thống.
                </p>

                {/* Feedback Type */}
                <div className="grid grid-cols-3 gap-2">
                  {[
                    { val: 'bug', label: 'Báo lỗi' },
                    { val: 'idea', label: 'Ý tưởng mới' },
                    { val: 'other', label: 'Ý kiến khác' }
                  ].map((type) => (
                    <button
                      type="button"
                      key={type.val}
                      onClick={() => setFeedbackType(type.val)}
                      className={cn(
                        "py-2 px-3 text-xs font-semibold rounded-xl border text-center transition-all",
                        feedbackType === type.val
                          ? "bg-orange-50 border-orange-500 text-orange-600 font-bold"
                          : "border-gray-200 text-gray-600 hover:bg-gray-50"
                      )}
                    >
                      {type.label}
                    </button>
                  ))}
                </div>

                {/* Feedback Content */}
                <div>
                  <label className="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1.5">Nội dung góp ý</label>
                  <textarea
                    rows={4}
                    value={feedbackContent}
                    onChange={(e) => setFeedbackContent(e.target.value)}
                    required
                    placeholder="Hãy miêu tả chi tiết trải nghiệm hoặc đóng góp của bạn..."
                    className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-orange-500 focus:ring-4 focus:ring-orange-500/10 outline-none text-sm resize-none placeholder:text-gray-400"
                  />
                </div>

                {/* Email (Optional) */}
                <div>
                  <label className="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-1.5">Email của bạn (không bắt buộc)</label>
                  <input
                    type="email"
                    value={feedbackEmail}
                    onChange={(e) => setFeedbackEmail(e.target.value)}
                    placeholder="Nhập email để chúng tôi phản hồi nếu cần"
                    className="w-full h-10 px-4 rounded-xl border border-gray-200 focus:border-orange-500 focus:ring-4 focus:ring-orange-500/10 outline-none text-sm placeholder:text-gray-400"
                  />
                </div>

                {/* Submit Action */}
                <div className="pt-2 flex items-center justify-end gap-2">
                  <button
                    type="button"
                    onClick={() => setShowFeedback(false)}
                    className="px-5 h-10 rounded-xl border border-gray-200 text-sm font-bold text-gray-600 hover:bg-gray-50 transition-colors"
                  >
                    Hủy bỏ
                  </button>
                  <button
                    type="submit"
                    className="px-6 h-10 rounded-xl bg-orange-500 text-white font-bold text-sm hover:bg-orange-600 transition-colors shadow-md shadow-orange-100 flex items-center gap-1.5"
                  >
                    <Send size={16} />
                    Gửi phản hồi
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}

      {/* ── MODAL 2: SUPPORT Details ── */}
      {showSupport && (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[999] flex items-center justify-center p-4 animate-in fade-in duration-300">
          <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 max-w-sm w-full overflow-hidden animate-in zoom-in-95 duration-200">

            {/* Header */}
            <div className="bg-gradient-to-r from-orange-500 to-orange-600 px-6 py-4 flex items-center justify-between text-white">
              <div className="flex items-center gap-2">
                <Headphones size={20} />
                <h3 className="font-bold text-base">Tổng đài Hỗ trợ</h3>
              </div>
              <button
                onClick={() => setShowSupport(false)}
                className="w-8 h-8 rounded-full hover:bg-white/20 flex items-center justify-center text-white transition-colors"
              >
                <X size={18} />
              </button>
            </div>

            {/* Support details */}
            <div className="p-6 space-y-4 text-center">
              <div className="w-16 h-16 rounded-full bg-orange-50 flex items-center justify-center text-orange-500 mx-auto">
                <Headphones size={32} />
              </div>
              <div>
                <h4 className="font-bold text-gray-800">FnBHub luôn bên bạn!</h4>
                <p className="text-xs text-gray-400 mt-0.5">Vui lòng liên hệ với chúng tôi qua các kênh dưới đây:</p>
              </div>

              <div className="space-y-2 pt-2 text-left">
                {/* Phone */}
                <a
                  href="tel:19001234"
                  className="flex items-center gap-3 p-3 rounded-xl border border-gray-100 hover:border-orange-200 hover:bg-orange-50/30 transition-all group"
                >
                  <div className="w-8 h-8 rounded-lg bg-orange-50 flex items-center justify-center text-orange-500 shrink-0">
                    <Phone size={16} />
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-gray-400">Hotline 24/7</p>
                    <p className="text-sm font-bold text-gray-700 group-hover:text-orange-600 transition-colors">1900 1234</p>
                  </div>
                </a>

                {/* Email */}
                <a
                  href="mailto:support@fnbhub.vn"
                  className="flex items-center gap-3 p-3 rounded-xl border border-gray-100 hover:border-orange-200 hover:bg-orange-50/30 transition-all group"
                >
                  <div className="w-8 h-8 rounded-lg bg-orange-50 flex items-center justify-center text-orange-500 shrink-0">
                    <Mail size={16} />
                  </div>
                  <div className="overflow-hidden">
                    <p className="text-xs font-semibold text-gray-400">Email phản hồi</p>
                    <p className="text-sm font-bold text-gray-700 group-hover:text-orange-600 transition-colors truncate">support@fnbhub.vn</p>
                  </div>
                </a>

                {/* Clock */}
                <div className="flex items-center gap-3 p-3 rounded-xl border border-gray-100/50 bg-gray-50/50">
                  <div className="w-8 h-8 rounded-lg bg-gray-100 flex items-center justify-center text-gray-400 shrink-0">
                    <Clock size={16} />
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-gray-400">Giờ làm việc</p>
                    <p className="text-sm font-bold text-gray-600">Thứ 2 - Chủ Nhật (8h00 - 22h00)</p>
                  </div>
                </div>
              </div>

              <div className="pt-2">
                <button
                  onClick={() => setShowSupport(false)}
                  className="w-full h-10 rounded-xl bg-orange-500 hover:bg-orange-600 text-white font-bold text-sm transition-colors shadow-md shadow-orange-100"
                >
                  Đồng ý
                </button>
              </div>
            </div>

          </div>
        </div>
      )}

      {/* ── MODAL 3: SECURITY Cam kết bảo mật ── */}
      {showSecurity && (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[999] flex items-center justify-center p-4 animate-in fade-in duration-300">
          <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 max-w-md w-full overflow-hidden animate-in zoom-in-95 duration-200">

            {/* Header */}
            <div className="bg-gradient-to-r from-orange-500 to-orange-600 px-6 py-4 flex items-center justify-between text-white">
              <div className="flex items-center gap-2">
                <ShieldCheck size={20} />
                <h3 className="font-bold text-base">Cam kết bảo mật & Xác thực</h3>
              </div>
              <button
                onClick={() => setShowSecurity(false)}
                className="w-8 h-8 rounded-full hover:bg-white/20 flex items-center justify-center text-white transition-colors"
              >
                <X size={18} />
              </button>
            </div>

            {/* Content */}
            <div className="p-6 space-y-4">
              <div className="flex flex-col items-center text-center space-y-2">
                <ShieldCheck size={48} className="text-orange-500" />
                <h4 className="font-bold text-gray-800 text-base">An tâm tin cậy cùng FnBHub</h4>
              </div>

              <div className="space-y-3 text-sm text-gray-600 max-h-[300px] overflow-y-auto pr-1">
                <div className="p-3 bg-orange-50/40 rounded-xl border border-orange-100/30">
                  <h5 className="font-bold text-orange-700 text-xs uppercase tracking-wider mb-1">🛡️ Bảo mật thông tin</h5>
                  <p className="text-xs leading-relaxed text-gray-600">
                    Toàn bộ hồ sơ ứng viên, thông tin doanh nghiệp nhượng quyền và các giao dịch chuyển nhượng được mã hóa đầu cuối bằng giao thức bảo mật SSL/TLS cao cấp nhất.
                  </p>
                </div>

                <div className="p-3 bg-orange-50/40 rounded-xl border border-orange-100/30">
                  <h5 className="font-bold text-orange-700 text-xs uppercase tracking-wider mb-1">✅ Xác thực Tin đăng</h5>
                  <p className="text-xs leading-relaxed text-gray-600">
                    Mỗi thương hiệu nhượng quyền và tin đăng sang nhượng đều được đội ngũ kiểm duyệt kiểm tra kỹ lưỡng giấy phép kinh doanh, thực tế cơ sở để loại bỏ hoàn toàn các tin giả, lừa đảo.
                  </p>
                </div>

                <div className="p-3 bg-orange-50/40 rounded-xl border border-orange-100/30">
                  <h5 className="font-bold text-orange-700 text-xs uppercase tracking-wider mb-1">🤝 Kết nối Trực tiếp</h5>
                  <p className="text-xs leading-relaxed text-gray-600">
                    Không qua trung gian nâng giá. Chúng tôi kết nối trực tiếp Người bán - Người mua, Ứng viên - Nhà tuyển dụng một cách minh bạch, công bằng.
                  </p>
                </div>
              </div>

              <div className="pt-2">
                <button
                  onClick={() => setShowSecurity(false)}
                  className="w-full h-10 rounded-xl bg-orange-500 hover:bg-orange-600 text-white font-bold text-sm transition-colors shadow-md shadow-orange-100"
                >
                  Tôi đã hiểu
                </button>
              </div>
            </div>

          </div>
        </div>
      )}
    </>
  );
}
